module.exports = __webpack_public_path__ + "html/editable_75730d9c10bd49cfa02f2f92174d6482.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/project/editable.html
// module id = GgDZ
// module chunks = 51